import React, { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Box,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import TopSection from "../../../Components/Common/Top/TopSection";
import ButtonComponent from "../../../Components/Common/button/Button";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../../utils/fetch";
import { MessagePopup } from "../../../Components/Common/messagePopup/MessagePopup";
import BottlerSelectionAccordion from "./BottlerSelectionAccordion";
import CustomBottlerSelectionAccordion from "./CustomBottlerSelectionAccordion";

import { setStPeriodList, setLtPeriodList } from "../../../redux/entitySlice";
import {
  setCustomStPeriodList,
  setCustomLtPeriodList,
} from "../../../redux/customEntitySlice";
import { Tabs, Tab } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useBottlerSelection } from "../../../context/BottlerSelectionContext";
import { useCustomBottler } from "../../../context/CustomBottlerContext";
import SettingsIcon from '@mui/icons-material/Settings';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DownloadIcon from '@mui/icons-material/Download';

const ForecastContent = () => {
  const [selectedForecast, setSelectedForecast] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [shortTermPeriodList, setShortTermPeriodList] = useState([]);
  const [longTermPeriodList, setLongTermPeriodList] = useState([]);
  const [forecastPeriod, setForecastPeriod] = useState([]);
  const [loading, setLoading] = useState(false); 
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const { selectedData } = useBottlerSelection();
  const manageForecastBottlerData = useSelector(
    (state) => state.entity.manageForecastBottlerData
  );

  const [activeTab, setActiveTab] = useState(0);

  const [selectedCustomForecast, setSelectedCustomForecast] = useState(null);
  const [selectedCustomPeriod, setSelectedCustomPeriod] = useState("");
  const [customShortTermPeriodList, setCustomShortTermPeriodList] = useState(
    []
  );
  const [customLongTermPeriodList, setCustomLongTermPeriodList] = useState([]);
  const [customForecastPeriod, setCustomForecastPeriod] = useState([]);
  const [isCustomUploading, setIsCustomUploading] = useState(false);
  const fileCustomInputRef = useRef(null);
  const { customSelectedData } = useCustomBottler();
  const customManageForecastBottlerData = useSelector(
    (state) => state.customEntity.customManageForecastBottlerData
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const stPeriodList = useSelector((state) => state.entity.shortTermPeriodList);
  const ltPeriodList = useSelector((state) => state.entity.longTermPeriodList);
  const customStPeriodList = useSelector(
    (state) => state.customEntity.customShortTermPeriodList
  );
  const customLtPeriodList = useSelector(
    (state) => state.customEntity.customLongTermPeriodList
  );

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location]);

  useEffect(() => {
    if (stPeriodList === null || stPeriodList.length === 0) {
      const fetchForecastPeriod = async () => {
        try {
          const response = await ApiService.get("/v1/get-forecast-period-list");
          setShortTermPeriodList(response.data.shortTermPeriodList);
          setLongTermPeriodList(response.data.longTermPeriodList);

          dispatch(setStPeriodList(response.data.shortTermPeriodList));
          dispatch(setLtPeriodList(response.data.longTermPeriodList));

          if (
            response.data.shortTermPeriodList.length ==
            response.data.longTermPeriodList.length
          ) {
            setForecastPeriod(response.data.longTermPeriodList);
          } else if (selectedForecast != null && selectedForecast != "") {
            setForecastPeriod(
              selectedForecast === "Short Term"
                ? shortTermPeriodList
                : longTermPeriodList
            );
          }
        } catch (error) {
          console.error("Error fetching forecast periods:", error);
        }
      };
      fetchForecastPeriod();
    } else {
      setShortTermPeriodList(stPeriodList);
      setLongTermPeriodList(ltPeriodList);
      if (stPeriodList.length == ltPeriodList.length) {
        setForecastPeriod(ltPeriodList);
      } else if (selectedForecast != null && selectedForecast != "") {
        setForecastPeriod(
          selectedForecast === "Short Term"
            ? shortTermPeriodList
            : longTermPeriodList
        );
      }
    }
  }, []);

  useEffect(() => {
    const isSameLength =
      shortTermPeriodList.length === longTermPeriodList.length;

    if (selectedForecast) {
      const periodList = isSameLength
        ? longTermPeriodList
        : selectedForecast === "Short Term"
        ? shortTermPeriodList
        : longTermPeriodList;

      setForecastPeriod(periodList);
    } else {
      if (!isSameLength) {
        setForecastPeriod([]);
        setSelectedPeriod(null);
      }
    }
  }, [selectedForecast]);

  useEffect(() => {
    if (customStPeriodList === null || customStPeriodList.length === 0) {
      const fetchCustomForecastPeriod = async () => {
        try {
          const response = await ApiService.get(
            "/v1/get-forecast-period-list/customUpload"
          );
          setCustomShortTermPeriodList(response.data.shortTermPeriodList);
          setCustomLongTermPeriodList(response.data.longTermPeriodList);
          dispatch(setCustomStPeriodList(response.data.shortTermPeriodList));
          dispatch(setCustomLtPeriodList(response.data.longTermPeriodList));

          if (
            response.data.shortTermPeriodList.length ==
            response.data.longTermPeriodList.length
          ) {
            setCustomForecastPeriod(response.data.longTermPeriodList);
          } else if (
            selectedCustomForecast != null &&
            selectedCustomForecast != ""
          ) {
            setCustomForecastPeriod(
              selectedCustomForecast === "Short Term"
                ? shortTermPeriodList
                : longTermPeriodList
            );
          }
        } catch (error) {
          console.error("Error fetching custom forecast periods:", error);
        }
      };
      fetchCustomForecastPeriod();
    } else {
      setCustomShortTermPeriodList(customStPeriodList);
      setCustomLongTermPeriodList(customLtPeriodList);
      if (customStPeriodList.length === customLtPeriodList.length) {
        setCustomForecastPeriod(customLtPeriodList);
      } else if (
        selectedCustomForecast != null &&
        selectedCustomForecast != ""
      ) {
        setCustomForecastPeriod(
          selectedCustomForecast === "Short Term"
            ? customStPeriodList
            : customLtPeriodList
        );
      }
    }
  }, []);

  useEffect(() => {
    const isSameLength =
      customShortTermPeriodList.length === customLongTermPeriodList.length;
    if (selectedCustomForecast) {
      const periodList = isSameLength
        ? customLongTermPeriodList
        : selectedCustomForecast === "Short Term"
        ? customShortTermPeriodList
        : customLongTermPeriodList;
      setCustomForecastPeriod(periodList);
    } else {
      if (!isSameLength) {
        setCustomForecastPeriod([]);
        setSelectedCustomPeriod(null);
      }
    }
  }, [selectedCustomForecast]);

  const cleanPeriod = (period) => period.replace(/-\w{3}$/, "");

  const handleProcess = async (e) => {
    e.preventDefault();

    if (!selectedForecast || !selectedPeriod || selectedData.length === 0) {
      MessagePopup({
        icon: "error",
        title: "Error!",
        message:
          "Please select Forecast Term, Forecast Period, and Bottler Selection!",
      });
      return;
    }

    setLoading(true); // Start the loader

    const payloadData = {
      forecastTerm: selectedForecast === "Short Term" ? 1 : 2,
      fiscalPeriodDesc: cleanPeriod(selectedPeriod),
      locationCustomerDTOList: selectedData,
    };

    try {
      const response = await ApiService.downloadFile(
        "/v1/generate-forecast-template",
        payloadData
      );

      if (response.status === 200 && response.data) {
        // Create an object URL for the Blob
        const url = window.URL.createObjectURL(response.data);

        // Generate a timestamp for the filename (optional)
        const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "_");

        // Set the filename for the download
        const filename = `Forecast_${selectedPeriod}_${selectedForecast}_${timestamp}1.xlsx`;

        // Create a temporary link to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        // Append the link to the document body, click it, then remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up the object URL to release memory
        URL.revokeObjectURL(url);

        MessagePopup({
          icon: "success",
          message: "Excel file downloaded successfully!",
        });
      }
    } catch (error) {
      console.error("Request Error:", error);

      const defaultMessage = "An error occurred while processing data.";
      let messageToShow = defaultMessage;

      try {
        const { response } = error;

        if (response) {
          const { status, data, headers } = response;
          const contentType = headers?.["content-type"] || "";

          if (data instanceof Blob) {
            const text = await data.text();

            if (contentType.includes("application/json")) {
              // Try parsing JSON error
              try {
                const json = JSON.parse(text);
                messageToShow = json.error || json.message || defaultMessage;
              } catch {
                messageToShow = text; // fallback to raw text
              }
            } else {
              messageToShow = text; // plain text or HTML error
            }
          } else if (status === 404) {
            messageToShow = "Requested resource not found (404).";
          }
        } else {
          // No response — likely a network or CORS error
          messageToShow = error.message || defaultMessage;
        }
      } catch (handlingError) {
        console.error("Error while handling the error:", handlingError);
        messageToShow = defaultMessage;
      }

      MessagePopup({
        icon: "error",
        title: "Error!",
        message: messageToShow,
      });
    } finally {
      setLoading(false); // Always stop loader
    }
  };

  const handleFileUpload = async (event) => {
    if (isUploading) return; // Prevent multiple clicks while loading

    if (!selectedForecast || !selectedPeriod || selectedData.length === 0) {
      MessagePopup({
        icon: "error",
        title: "Error!",
        message:
          "Please select Forecast Term, Forecast Period, and Bottler Selection!",
      });
      return;
    }

    const selectedFile = event.target.files[0];
    if (!selectedFile) {
      MessagePopup({
        icon: "error",
        title: "Error!",
        message: "Please select a file!",
      });
      return;
    }

    const uploadRequestDTO = {
      bottlerCode: manageForecastBottlerData,
      locationCustomerList: selectedData,
      fiscalMonthDescrption: cleanPeriod(selectedPeriod),
      forecastTerm: selectedForecast === "Short Term" ? 1 : 2,
    };

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("uploadRequestDTOJson", JSON.stringify(uploadRequestDTO));

    setIsUploading(true); // Start the loader

    MessagePopup({
      title: "Confirm Submission of Forecast",
      html: `<p>Are you sure you want to submit the <span class="red-text">${selectedForecast} Forecast</span> for the selected combination ?</p>
             <p>File selected: ${selectedFile.name} </p>`,
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#000000",
      cancelButtonColor: "#808080",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await ApiService.uploadAndDownload(
            "/v1/validate-and-process-upload",
            formData
          );

          const validationResult = response.headers?.["x-validation-result"];

          if (validationResult === "SUCCESS") {
            MessagePopup({
              icon: "success",
              title: "Upload Completed",
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          } else if (validationResult === "FAILED") {
            // Create an object URL for the Blob
            const url = window.URL.createObjectURL(response.data);

            // Generate a timestamp for the filename (optional)
            const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "_");

            // Set the filename for the download
            const filename = `Forecast_Sanity_ErrorReport_${selectedPeriod}_${selectedForecast}_${timestamp}1.xlsx`;

            // Create a temporary link to trigger the download
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);

            // Append the link to the document body, click it, then remove it
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up the object URL to release memory
            URL.revokeObjectURL(url);

            MessagePopup({
              icon: "error",
              title: "Upload Failed",
              html: `<p class="red-text"> Multiple errors found in the uploaded file. A report has been downloaded for your review </p>`,
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          } else {
            MessagePopup({
              icon: "error",
              title: "Upload Failed",
              html: `<p class="red-text"> Error While Processing the Upload </p>`,
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          }
        } catch (error) {
          console.log(error);
          let text = "Error While Processing the upload";
          if (error.response.data instanceof Blob) {
            text = await error.response.data.text();
          }
          MessagePopup({
            icon: "error",
            title: "Upload Failed",
            html: `<p class="red-text"> ${text} </p>`,
            confirmButtonText: "Ok",
            confirmButtonColor: "#000000",
          });
        } finally {
          setIsUploading(false); // Stop the loader
        }
      } else {
        setIsUploading(false); // Stop the loader if canceled
      }
    });
  };

  const handleCustomFileUpload = async (event) => {
    if (isCustomUploading) return;
    if (
      !selectedCustomForecast ||
      !selectedCustomPeriod ||
      customSelectedData.length === 0
    ) {
      MessagePopup({
        icon: "error",
        title: "Error!",
        message: "Please select Forecast Term, Forecast Period, Bottler Selection",
      });
      return;
    }

    const selectedFile = event.target.files[0];
    if (!selectedFile) {
      MessagePopup({
        icon: "error",
        title: "Error!",
        message: "Please select a file!",
      });
      return;
    }

    const uploadRequestDTO = {
      bottlerCode: customManageForecastBottlerData,
      locationCustomerList: customSelectedData,
      fiscalMonthDescrption: cleanPeriod(selectedCustomPeriod),
      forecastTerm: selectedCustomForecast === "Short Term" ? 1 : 2,
    };

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("uploadRequestDTOJson", JSON.stringify(uploadRequestDTO));

    setIsCustomUploading(true);

    MessagePopup({
      title: "Confirm Submission of Forecast",
      html: `<p>Are you sure you want to submit the <span class="red-text">${selectedCustomForecast} Forecast</span> for the selected combination ?</p>
             <p>File selected: ${selectedFile.name} </p>`,
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#000000",
      cancelButtonColor: "#808080",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await ApiService.uploadAndDownload(
            "/v1/validate-and-process-upload/custom",
            formData
          );
          const validationResult = response.headers?.["x-validation-result"];
          if (validationResult === "SUCCESS") {
            MessagePopup({
              icon: "success",
              title: "Upload Completed",
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          } else if (validationResult === "FAILED") {
            const url = window.URL.createObjectURL(response.data);
            const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "_");
            const filename = `Custom_Forecast_Sanity_ErrorReport_${selectedCustomPeriod}_${selectedCustomForecast}_${timestamp}1.xlsx`;

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            MessagePopup({
              icon: "error",
              title: "Upload Failed",
              html: `<p class="red-text">Errors found in the uploaded file. A report has been downloaded for your review </p>`,
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          } else {
            MessagePopup({
              icon: "error",
              title: "Upload Failed",
              html: `<p class="red-text"> Error While Processing the Upload </p>`,
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          }
        } catch (error) {
          console.log(error);
          let text = "Error While Processing the upload";
          if (error.response?.data instanceof Blob) {
            text = await error.response.data.text();
          }
          MessagePopup({
            icon: "error",
            title: "Upload Failed",
            html: `<p class="red-text"> ${text} </p>`,
            confirmButtonText: "Ok",
            confirmButtonColor: "#000000",
          });
        } finally {
          setIsCustomUploading(false);
        }
      } else {
        setIsCustomUploading(false);
      }
    });
  };

  const forecastType = ["Short Term", "Long Term"];
  const CustomForecastType = ["Short Term", "Long Term"];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const templateConfiguration = () => {
    navigate("/mapping-configuration");
  };

  return (
    <Stack spacing={1} sx={{ padding: "10px" }}>
      <TopSection
        labelList={[
          { title: "Home", path: "/dashboard" },
          { title: "Manage Forecast" },
        ]}
        title="Manage Concentrate Forecast File"
      />
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 500,
              minWidth: "200px",
            },
          }}
        >
          <Tab label="Standard Coke Template" />
          <Tab label="Custom Bottler Template" />
        </Tabs>
      </Box>
      <Box role="tabpanel" hidden={activeTab !== 0}>
        {activeTab === 0 && shortTermPeriodList.length > 0 && (
          <Grid container>
            <Grid item xs={8} spacing={1}>
              <Box sx={{ padding: "10px", borderRadius: "10px" }}>
                <Grid container spacing={3} mt={-1.75}>
                  <Grid item md={6} xs={12}>
                    <Autocomplete
                      disablePortal
                      options={forecastType}
                      size="small"
                      value={selectedForecast}
                      onChange={(event, newValue) =>
                        setSelectedForecast(newValue)
                      }
                      sx={{ width: "100%" }}
                      renderInput={(params) => (
                        <TextField {...params} label="Forecast Term *" />
                      )}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Autocomplete
                      disablePortal
                      options={forecastPeriod}
                      getOptionLabel={(option) => option}
                      size="small"
                      value={selectedPeriod}
                      onChange={(event, newValue) =>
                        setSelectedPeriod(newValue)
                      }
                      sx={{ width: "100%" }}
                      renderInput={(params) => (
                        <TextField {...params} label="Forecast Period *" />
                      )}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Stack direction="row" spacing={2} mt={2} marginLeft={2}>
                <ButtonComponent
                  label={loading ? "Processing..." : "Download Template"}
                  bgColor="black"
                  color="white"
                  onClick={handleProcess}
                  disabled={loading}
                  startIcon={<DownloadIcon />}
                />
                <ButtonComponent
                  label={isUploading ? "Uploading..." : "Upload Forecast"}
                  bgColor="black"
                  color="white"
                  onClick={() => {
                    if (
                      !selectedForecast ||
                      !selectedPeriod ||
                      selectedData.length === 0
                    ) {
                      MessagePopup({
                        icon: "error",
                        title: "Error!",
                        message:
                          "Please select Forecast Term, Forecast Period, and Bottler Selection!",
                      });
                      return;
                    }
                    if (fileInputRef.current) {
                      fileInputRef.current.value = "";
                      fileInputRef.current.click();
                    }
                  }}
                  disabled={isUploading}
                  startIcon={<FileUploadIcon />}
                />
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                />
              </Stack>
              <Box sx={{ marginLeft: 2, marginTop: 5 }}>
                <Typography variant="body3" color="red" fontStyle="italic">
                  Make sure you upload the forecast file with only the selected
                  combinations.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4} marginTop={-2}>
              <Box sx={{ padding: "10px", borderRadius: "10px" }}>
                <Typography gutterBottom style={{ marginBottom: "-10px" }}>
                  Bottler Selection *
                </Typography>
                <BottlerSelectionAccordion
                  selectedPeriod={selectedPeriod}
                  selectedTerm={selectedForecast}
                  hasSameSubmission={
                    shortTermPeriodList.length === longTermPeriodList.length
                  }
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </Box>

      <Box role="tabpanel" hidden={activeTab !== 1}>
        {activeTab === 1 && customShortTermPeriodList.length > 0 && (
          <Grid container>
            <Grid item xs={8} spacing={1}>
              <Box sx={{ padding: "10px", borderRadius: "10px" }}>
                <Grid container spacing={3} mt={-1.75}>
                  <Grid item md={6} xs={12}>
                    <Autocomplete
                      disablePortal
                      options={CustomForecastType}
                      size="small"
                      value={selectedCustomForecast}
                      onChange={(event, newValue) =>
                        setSelectedCustomForecast(newValue)
                      }
                      sx={{ width: "100%" }}
                      renderInput={(params) => (
                        <TextField {...params} label="Forecast Term *" />
                      )}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Autocomplete
                      disablePortal
                      options={customForecastPeriod}
                      getOptionLabel={(option) => option}
                      size="small"
                      value={selectedCustomPeriod}
                      onChange={(event, newValue) =>
                        setSelectedCustomPeriod(newValue)
                      }
                      sx={{ width: "100%" }}
                      renderInput={(params) => (
                        <TextField {...params} label="Forecast Period *" />
                      )}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Stack direction="row" spacing={2} mt={2} marginLeft={2}>
                <ButtonComponent
                  label="Configuration"
                  bgColor="black"
                  color="white"
                  onClick={templateConfiguration}
                  startIcon={<SettingsIcon />}
                />
                <ButtonComponent
                  label={isCustomUploading ? "Uploading..." : "Upload Forecast"}
                  bgColor="black"
                  color="white"
                  startIcon={<FileUploadIcon />}
                  onClick={() => {
                    if (!selectedCustomForecast || !selectedCustomPeriod || customSelectedData.length===0) {
                      MessagePopup({
                        icon: "error",
                        title: "Error!",
                        message: "Please select Forecast Term, Forecast Period, Bottler Selection",
                      });
                      return;
                    }
                    if (fileCustomInputRef.current) {
                      fileCustomInputRef.current.value = "";
                      fileCustomInputRef.current.click();
                    }
                  }}
                  disabled={isCustomUploading}
                />
                <input
                  type="file"
                  ref={fileCustomInputRef}
                  style={{ display: "none" }}
                  onChange={handleCustomFileUpload}
                />
              </Stack>
              <Box sx={{ marginLeft: 2, marginTop: 5 }}>
                <Typography variant="body3" color="red" fontStyle="italic">
                  Make sure you upload the forecast file with only the selected
                  combinations.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4} marginTop={-2}>
              <Box sx={{ padding: "10px", borderRadius: "10px" }}>
                {/* <Typography gutterBottom style={{ marginBottom: "-10px" }}>
                  Bottler Selection *
                </Typography> */}
                <CustomBottlerSelectionAccordion
                  selectedPeriod={selectedCustomPeriod}
                  selectedTerm={selectedCustomForecast}
                  hasSameSubmission={
                    customShortTermPeriodList.length ===
                    customLongTermPeriodList.length
                  }
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </Box>
    </Stack>
  );
};

export default ForecastContent;
